// @flow
// @jsx h
import { h, Component, createRef } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import ReactFlagsSelect from 'react-flags-select'
//import "react-flags-select/css/react-flags-select.css";


const ReactFlagsSelectExtension = (props) => {
    const [selected, setSelected] = useState(props.defaultCountry || 'FR');

    const catalogneSVG = `<?xml version="1.0" encoding="UTF-8"?>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 512 336" version="1.1">
    <g id="surface1">
    <rect x="0" y="0" width="512" height="336" style="fill:rgb(98.823529%,86.666667%,3.529412%);fill-opacity:1;stroke:none;"/>
    <path style="fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;stroke-width:60;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(85.490196%,7.058824%,10.196078%);stroke-opacity:1;stroke-miterlimit:4;" d="M 0 90 L 810 90 M 810 210.002093 L 0 210.002093 M 0 329.997907 L 810 329.997907 M 810 450 L 0 450 " transform="matrix(0.632099,0,0,0.622222,0,0)"/>
    </g>
    </svg>`;

    const flagSelectRef = useRef(null);
    const wrapperRef = useRef(null);

    useEffect(() => {
      const svgElement = wrapperRef.current.querySelector('svg');
      if (selected.toLowerCase() === 'pl' && svgElement) {
        const newSVG = new DOMParser().parseFromString(catalogneSVG, 'image/svg+xml').documentElement;
        svgElement.replaceWith(newSVG);
      }
    }, [selected]);

    const handleSelect = (code) => {
      setSelected(code);
      const svgElement = wrapperRef.current.querySelector('svg');
      if (props.onSelect && selected != code) {
        svgElement.remove()
        props.onSelect(code);
      }
    };

    const handleOpenOptions = () => {
      const optionsElement = wrapperRef.current.querySelector('li#rfs-PL svg');
      if (optionsElement) {
        const newSVG = new DOMParser().parseFromString(catalogneSVG, 'image/svg+xml').documentElement;
        optionsElement.replaceWith(newSVG);
      }
    };

  return (
    <div ref={wrapperRef} onClick={handleOpenOptions} >
      <ReactFlagsSelect
        {...props}
        ref={flagSelectRef}
        selected={selected}
        onSelect={handleSelect}
      />
    </div>
  );
}

export default ReactFlagsSelectExtension;
